import { isTouchDevice } from "./device-detection";

const TAG_LINE = "Locally Owned and Operated";
export function localizationTagLine(){
    const tagLine = document.querySelector('.header-wrapper .description')as HTMLSpanElement;
    const dbaName = localStorage.getItem('dbaName');
    //replace the tage line even if the page is national provided the user is localized
    const existingTagLine = localStorage.getItem('localTagLine') ?? TAG_LINE;
    if(dbaName && existingTagLine && tagLine){
        tagLine.innerHTML = existingTagLine ?? TAG_LINE;
    }

}

export function localizationMobileDBATitle(){
    if (!isTouchDevice()) return;

    const sessionBrandData = sessionStorage.getItem('brandDetails');
    const brandData = sessionBrandData ? JSON.parse(sessionBrandData) : {};
        
    const localDBAMobileHeader = document.querySelector(".local-owned.mobile-only") as HTMLDivElement;

    if (localDBAMobileHeader && !brandData?.disable_mobile_dba_os_flow) {
        updateDBAInfo(localDBAMobileHeader);
    }
}

function updateDBAInfo(header: HTMLDivElement) {
    const dbaName = localStorage.getItem("doingBusinessAs");
    const franchiseWebLocationId = localStorage.getItem("franchiseWebLocationId");
    if (franchiseWebLocationId && dbaName) {
        header.classList.remove('hidden');
        
        const localTitle = header.querySelector('.local-title');
        const localTagLine = header.querySelector('.local-subtitle');
        if (localTitle) {
            header.style.backgroundColor = "rgb(255 255 255)";
            localTitle.textContent = dbaName;
        }
        if (localTagLine) {
            localTagLine.innerHTML = localStorage.getItem('localTagLine') ?? TAG_LINE;
        }
    }
}

export function localizationTagUpadation(){
    const localTagLine = localStorage.getItem('localTagLine')
    if(localStorage.getItem('dbaName')){
        let replaceText = localTagLine ?? TAG_LINE ;
        localStorage.setItem('localTagLine', replaceText);
    }
}

export function setDBAandLocationPin(){
    const doingBusinessAs = localStorage.getItem('doingBusinessAs');
    const localTagLine = localStorage.getItem('localTagLine');
    let parsedImage =''
    if(localTagLine && localTagLine.includes('<img')){
        parsedImage = '<img'+localTagLine.split('<img')[1].split('>')[0]+ '>';
    }else{
        parsedImage = `<svg aria-hidden="true" class="icon"> <use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#map-pin-primary"></use></svg>`;
    }
    // Feature 634665 - MDG/PLG Header with Local Address/Phone Number for Insurance
    // When the Location Info panel is authored (CP outputs data-location-info-toggle on the trigger),
    // the trigger label reads "Location Info" instead of "Change location" and opens the in-page panel
    // instead of the Location Finder modal directly. The label itself comes from the dedicated
    // data-location-info-label attribute (not "title", which holds the classic-mode "open in new
    // tab-modal" description used before localization is confirmed).
    const trigger = document.querySelector<HTMLElement>('.find-local-mobile');
    const isLocationInfoPanel = trigger?.hasAttribute('data-location-info-toggle');
    const linkLabel = isLocationInfoPanel ? (trigger?.dataset.locationInfoLabel || 'Location Info') : 'Change location';
    return `${parsedImage}<div><span class="local-address">${doingBusinessAs}</span><span class="location__link">${linkLabel}</span></div>`;
}

